import { render, staticRenderFns } from "./subheader.vue?vue&type=template&id=c68cb012"
import script from "./subheader.vue?vue&type=script&lang=js"
export * from "./subheader.vue?vue&type=script&lang=js"
import style0 from "./subheader.vue?vue&type=style&index=0&id=c68cb012&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/opt/build/src/oncheckbuild_FutureGAJDKUpgrade90d6697d/FL2FL3nodefinapp/subbrandtool/client/1.0/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
installComponents(component, {VBtn,VFlex,VIcon,VLayout,VSpacer})
